import commonApiAuthRequest from "../apiAuthRequest"
import { PASSPORT_REFERENCE_URL } from "./constants"

const equipmentFetch = objectCode =>
  commonApiAuthRequest({
    url: `${PASSPORT_REFERENCE_URL}/objects/data/rowByKey/object/v1/${objectCode}`,
    params: {},
  })

/**
 * makes request to get equipment from reference by it's code
 *
 * @param {number} objectCode
 * @return {Array.<Object>} response - equipment
 */
export const getEquipment = async objectCode => {
  if (!objectCode) {
    return undefined
  }

  const { data: visits } = await equipmentFetch(objectCode)

  return visits
}
